import { useEffect, useState } from "react";

export function useShouldAnimateQuestions() {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // Use setTimeout to ensure initial render returns false
    // Then enable animation for any subsequent dynamic questions
    const timer = setTimeout(() => {
      setShouldAnimate(true);
    }, 0);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return shouldAnimate;
}
